/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created at Thu Dec 19 2024
 **/
import { useEffect } from "react";
import { timer } from "rxjs";

import { useMiniChatPopupManager } from "@/frameworks/core/hooks";

export default function useChatListFocusScroll(targetID: string | undefined) {
	const { miniChatPopupActions } = useMiniChatPopupManager();
	const currentFocus = miniChatPopupActions.getCurrentFocus();

	useEffect(() => {
		if (currentFocus?.id !== targetID || !targetID) return;

		const elementId = `panelRoom-${targetID}`;
		const targetElement = document.getElementById(elementId);

		if (!targetElement) return;

		targetElement.scrollIntoView({ behavior: "smooth", block: "center" });
		targetElement.classList.add("flash-animation");

		const subscription = timer(2000).subscribe(() => {
			targetElement.classList.remove("flash-animation");
		});

		return () => subscription.unsubscribe();
	}, [currentFocus]);
}
